
import React from "react";
import { useNavigate } from "react-router-dom";
import { validateForm } from "utils/validation";
import { PackageFoodTypeRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import AddPFTLForm from "./Componates/AddPFTLForm";
import fields from "../json/FoodListFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchAllData from "Hooks/useFetchAllData";
import {
  Create,
  getFoodTypes,
  getFoodPackage
} from "adminApi/PackageFoodTypeLimitApi/PackageFoodTypeLimit.js";

const AddPFTL = () => {

  const navigate = useNavigate();
  const { formdata } = fields;

  // Initialize form values from JSON fields
  const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

  const { values, errors, handleChange, setErrors } = useFormChange(
    initialValues,
    PackageFoodTypeRules
  );

  const { data: FoodTypesOptions = [] } = useFetchAllData(getFoodTypes);
  const { data: FoodPackageOptions = [] } = useFetchAllData(getFoodPackage);

  // Form submit
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      const formData = new FormData();
      Object.entries(formValues).forEach(([key, val]) => formData.append(key, val ?? ""));
      return await Create({ data: formData });
    },
    (vals) => {
      const err = validateForm(vals, PackageFoodTypeRules)
      setErrors(err);
      return err;
    },
    () => navigate(-1),
    "Create Package Food Type Limit Successfully"
  );

  return (
    <>
      {(loadingSubmit) && <Spinner isSpinner={true} />}
      <AddPFTLForm
        fields={formdata}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        FoodTypesOptions={FoodTypesOptions}
        FoodPackageOptions={FoodPackageOptions}
        title="Create Package Food Type Limit"
      />
    </>
  );

};

export default AddPFTL;
